<!--
 * @FileDescription: 图片轮播组件
 * @Author: 作者信息
 * @Date: 文件创建时间
 * @LastEditors: dcq
 * @LastEditTime: 2023-07-26 11:44:00
 -->
 <template>
    <DvBorderBox1 class="pic-template" :order="order" :keyId="keyId">
      <div class="pic-container" >
        <el-carousel height="100%" class="pic-carousel" ref="searchPicCarousel" indicator-position="none" :autoplay="false">
          <el-carousel-item v-for="item in picInfo3" :key="item.properties.name">
            <img :src="item.properties.imgUrl" class="image-bg">
          </el-carousel-item>
        </el-carousel>
      </div>
    </DvBorderBox1>
  </template>
  
  <script>
  export default {
    name: 'PicCarouselTemplate',
  }
  </script>
  
  <script setup>
  import { defineProps, ref, watch ,onMounted} from 'vue';
  import { BorderBox1 as DvBorderBox1 } from '@kjgl77/datav-vue3';
  import axios from 'axios';
  // import { locatSearchData} from './schoolData';
  // import activeJson from "@/components/activeChartData.json"
  
  let props = defineProps({
    order: String,
    schoolIndex: Number,
    keyId: String,
    searchSciIndex: Number
  });
  console.log('pic porps', props.searchSciIndex)
  
//   let unionPicCarousel = ref();
  let searchPicCarousel = ref();
  let activeJson=ref({})
  let picInfo3 = ref([])

  onMounted(() => {
    axios.get('/activeChartData.json')
      .then(response => {
        activeJson.value= response.data;
        picInfo3.value=activeJson.value.searchSciPt.features
        // searchInformation.value[0]={ name: '园区', val: searchNum.value + '所' }
      })
      .catch(error => {
        console.log(error);
      });
  }),
  
//   const picInfo1 = schoolData;
  // const picInfo2 = locatSearchData;
  // const picInfo3 = activeJson.searchSciPt.features;
  
  watch(props, (newProps) => {
    // unionPicCarousel.value.setActiveItem(newProps.schoolIndex - 1);
    searchPicCarousel.value.setActiveItem(newProps.searchSciIndex - 1);
  })
  // onMounted(() => {
  //   picCarousel.value.setActiveItem(props.schoolIndex - 1);
  // })
  
  </script>
  
  
  <style lang="scss" scoped>
  $orders: 1, 2, 3, 4, 5, 6, 7, 8;
  
  div.dv-border-box-1 {
    &[keyId="2"] {
      position: absolute;
      margin-top: 1vh;
      margin-bottom: 1vh;
      width: 42vw;
      height: 40vh;
    }
    &[keyId="3"] {
      position: absolute;
      right: 1.2vw;
      top: 3vh;
      // margin-top: 2vh;
      // margin-bottom: 1vh;
      width: 32vw;
      height: 36vh;
      z-index: 12;
    }
  
    @each $order in $orders {
      &[order='#{$order}'] {
        order: $order;
      }
    } 
  
    div.border-box-content {
      width: 40vw;
      height: 38vh;
      // border-radius: 20px;
  
      div.pic-container {
        position: absolute;
        top: 2%;
        left: 1.5%;
        width: 97%;
        height: 96%;
        z-index: 8;
        border-radius: 24px;
        overflow: hidden;
  
        .pic-carousel {
          width: 100%;
          height: 100%;
  
          .el-carousel__container {
            width: 100%;
            height: 100%;
  
            .image-bg {
              height: 100%;
              width: 100%;
              // background-image: url('http://223.2.9.189:8080/image/南京师范大学吴江实验幼儿园（图片1）.jpg');
              background-repeat: no-repeat;
              background-size: cover;
              // backdrop-filter: blur(10px);
              // background-color: rgba(0, 0, 0, 0.5);
            }
          }
        }
      }
  
    }
  }
  </style>
  